module.exports = __webpack_public_path__ + "static/fonts/TTNorms-Bold.41d77a7.ttf";